













































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class PaginaPreview extends Vue {
  private menu: any = "";
  private menu_cementerio: any = "";
  private menuLateral: any = [];
  private pagina: any = {
    id: "",
    titulo: "",
    nombre_web: "",
    fecha: "",
    banner: "",
    banner_mobile: "",
    contenido: "",
    direccion: "",
    telefono: "",
    email: "",
    horario: "",
    director: "",
    fecha_modificacion: "",
    tipo: "",
    estado: "",
    menu_lateral: ""
  };
  private nombreWeb: any = "";
  private columnasTablaData = [
    {
      name: "nombre",
      label: "Documento",
      align: "left"
    },
    {
      name: "dato",
      label: "Acción",
      align: "left"
    }
  ];
  private dataPagina: any = [];

  get muestraMenu() {
    if (
      this.pagina &&
      this.pagina.menu_lateral == 1 &&
      this.menuLateral.length > 0
    ) {
      return " col-xs-11 col-sm-11 col-md-8 col-lg-8 col-xl-8";
    }
    return " col-xs-11 col-sm-11 col-md-11 col-lg-11 col-xl-11";
  }

  private beforeMount() {
    if (
      this.$router.currentRoute.params.nombre &&
      this.$router.currentRoute.params.nombre != ""
    ) {
      this.nombreWeb = this.$router.currentRoute.params.nombre;
      this.getPagina();
    } else {
      this.routerGo("Home");
    }
  }

  private mounted() {}

  private getPagina() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get("preview/pagina?nombre_web=" + this.nombreWeb)
      .then((res: any) => {
        let base = process.env.VUE_APP_BASE_URL;
        this.pagina = res.data;
        if (this.pagina.banner) {
          this.pagina.banner = base + this.pagina.banner;
        } else {
          this.pagina.banner = base + "bannerPagina/default.jpg";
        }
        if (this.pagina.banner_mobile) {
          this.pagina.banner_mobile = base + this.pagina.banner_mobile;
        } else {
          this.pagina.banner_mobile = base + "bannerPagina/default_mobile.jpg";
        }
        document.title =
          this.pagina.titulo + " - Ilustre Municipalidad de Punta Arenas";
        if (this.pagina.director && this.pagina.director != "") {
          this.dataPagina.push({
            nombre: "Director/a",
            dato: this.pagina.director
          });
        }
        if (this.pagina.direccion && this.pagina.direccion != "") {
          this.dataPagina.push({
            nombre: "Dirección",
            dato: this.pagina.direccion
          });
        }
        if (this.pagina.email && this.pagina.email != "") {
          this.dataPagina.push({
            nombre: "Correo",
            dato: this.pagina.email
          });
        }
        if (this.pagina.telefono && this.pagina.telefono != "") {
          this.dataPagina.push({
            nombre: "Teléfono",
            dato: this.pagina.telefono
          });
        }
        if (this.pagina.horario && this.pagina.horario != "") {
          this.dataPagina.push({
            nombre: "Horario",
            dato: this.pagina.horario
          });
        }
        this.setMenu();
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        console.log(err);
        this.routerGo("Home");
      });
  }

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }

  private llamar() {
    const numero = this.pagina.telefono;
    window.open("tel:" + numero);
  }

  private sendMail() {
    const correo = this.pagina.email;
    window.open("mailto:" + correo);
  }

  private irGoogleMaps() {
    window.open(
      "https://www.google.com/maps/search/?api=1&query=" + this.pagina.direccion
    );
  }

  private async setMenu() {
    const runtimeConfig1 = await fetch(
      "https://admin.puntaarenas.cl/menu.json"
    );
    this.menu = await runtimeConfig1.json();
    const runtimeConfig2 = await fetch(
      "https://admin.puntaarenas.cl/cementerio.json"
    );
    this.menu_cementerio = await runtimeConfig2.json();
    if (this.pagina.menu_lateral == 1) {
      for (let i = 0; i < this.menu.length; i++) {
        this.getSubMenu(this.menu[i], this.pagina.nombre_web, 1);
      }
      for (let i = 0; i < this.menu_cementerio.length; i++) {
        if (this.menu_cementerio[i].nombre_web == this.pagina.nombre_web) {
          this.menuLateral = this.menu_cementerio;
          break;
        }
      }
    }
  }

  private getSubMenu(element: any, nombre_web: string, profundidad) {
    if (element.nombre_web == nombre_web) {
      return true;
    } else {
      if (element.sub_menu && element.sub_menu.length > 0) {
        for (let j = 0; j < element.sub_menu.length; j++) {
          if (
            this.getSubMenu(element.sub_menu[j], nombre_web, profundidad + 1)
          ) {
            if (profundidad == 2) {
              return true;
            } else {
              this.menuLateral = element.sub_menu;
              this.checkSubMenus();
              return false;
            }
          }
        }
      }
      return false;
    }
  }

  private selectedStyle(item: any) {
    if (this.$router.currentRoute.params.nombre == item.nombre_web) {
      item.expand = true;
      return " background-color: #02436b !important; color: #f1f1f1 !important;font-family: 'RubikBold' !important;";
    } else {
      let childSelected = false;
      if (item.sub_menu && item.sub_menu.length > 0) {
        for (let i = 0; i < item.sub_menu.length; i++) {
          if (
            this.$router.currentRoute.params.nombre ==
            item.sub_menu[i].nombre_web
          ) {
            childSelected = true;
          }
        }
        if (childSelected) {
          item.expand = true;
          return " background-color: #02436b !important; color: #f1f1f1 !important;font-family: 'RubikBold' !important;";
        }
      }
      return "";
    }
  }

  private checkSubMenus() {
    for (let i = 0; i < this.menuLateral.length; i++) {
      if (this.menuLateral[i].sub_menu.length > 0) {
        if (
          this.menuLateral[i].tipo == 2 &&
          this.$router.currentRoute.params.nombre ==
            this.menuLateral[i].nombre_web
        ) {
          this.menuLateral[i].expand = true;
        }
      } else {
        this.menuLateral[i].expand = false;
      }
    }
  }
  private toLink(item: any, blank: any) {
    if (item && item != "") {
      if (blank == 1) {
        window.open(item, "_blank");
      } else {
        window.open(item, "_self");
      }
    } else {
      return;
    }
  }

  private irPagina(nombreWeb: any) {
    if (nombreWeb == "contacto") {
      this.routerGo("Contacto");
    } else if (nombreWeb == "concejo-municipal" || nombreWeb == "concejo") {
      this.routerGo("Concejo");
    } else if (
      nombreWeb == "actas-del-concejo" ||
      nombreWeb == "actas-del-concejo-municipal"
    ) {
      this.routerGo("ActasConcejo");
    } else if (
      nombreWeb == "oficinas-y-telefonos-municipales" ||
      nombreWeb == "contactos"
    ) {
      this.routerGo("Telefonos");
    } else if (
      nombreWeb == "organigrama-municipal" ||
      nombreWeb == "organigrama"
    ) {
      this.routerGo("Organigrama");
    } else if (nombreWeb == "cosoc") {
      this.routerGo("Cosoc");
    } else if (nombreWeb == "informes-financieros") {
      this.routerGo("Informes");
    } else if (nombreWeb == "ordenanzas-municipales") {
      this.routerGo("Ordenanzas");
    } else if (nombreWeb == "ofertas-laborales") {
      this.routerGo("OfertasOmil");
    } else {
      if (nombreWeb && nombreWeb != "") {
        if (
          this.$router.currentRoute.name == "Pagina" &&
          this.$router.currentRoute.params.nombre &&
          this.$router.currentRoute.params.nombre == nombreWeb
        ) {
          this.$router.go(0);
        } else {
          if (this.$router.currentRoute.name == "Pagina") {
            if (
              this.$router.currentRoute.params.nombre &&
              this.$router.currentRoute.params.nombre != nombreWeb
            ) {
              this.$router
                .push({ name: "Pagina", params: { nombre: nombreWeb } })
                .catch(err => {
                  console.log(err);
                });
              this.$router.go(0);
            } else {
              this.$router
                .push({ name: "Pagina", params: { nombre: nombreWeb } })
                .catch(err => {
                  console.log(err);
                });
            }
          } else {
            this.$router
              .push({ name: "Pagina", params: { nombre: nombreWeb } })
              .catch(err => {
                console.log(err);
              });
          }
        }
      }
    }
  }
}
